/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol extends models.ServiceAccountCredentialsBaseForGcpServiceAccountProtocol {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol>): ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol(), model);
        ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol>): ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol.newInstance(<ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForGcpServiceAccountProtocol.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForGcpBillingAccountServiceAccountProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Project Id in which the billing bucket exists. This is a required field.
     */
    project_id: string;

    /**
     * Bucket Name. This is a required field.
     */
    bucket_name: string;

    /**
     * DataSet Id. This is a required field.
     */
    data_set_id: string;

    /**
     * Export Type. This is a required field.
     */
    export_type: string;

}
